import { render } from "./sidebarNavigation.vue?vue&type=template&id=77c17c85"
import script from "./sidebarNavigation.vue?vue&type=script&lang=js"
export * from "./sidebarNavigation.vue?vue&type=script&lang=js"

import "./sidebarNavigation.vue?vue&type=style&index=0&id=77c17c85&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__